"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _helpers = require("./helpers");

var _ItemCard = _interopRequireDefault(require("../ItemCard"));

var _styles = _interopRequireDefault(require("./styles"));

var SupplierHeader = _styles["default"].SupplierHeader,
    Row = _styles["default"].Row,
    Column = _styles["default"].Column,
    PageCountContainer = _styles["default"].PageCountContainer;

var SupplierRow = function SupplierRow(props) {
  var isAvailable = props.isAvailable,
      maxItems = props.maxItems,
      mobile = props.mobile,
      onLocationClick = props.onLocationClick,
      supplier = props.supplier,
      config = props.config,
      searchTerm = props.searchTerm,
      env = props.env,
      items = props.items,
      loading = props.loading,
      query = props.query,
      setCurItem = props.setCurItem;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      filteredItems = _useState2[0],
      setFilteredItems = _useState2[1];

  var _useState3 = (0, _react.useState)(maxItems),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      rowLength = _useState4[0],
      setRowLength = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      supplierUrl = _useState6[0],
      setSupplierUrl = _useState6[1];

  var partList = items ? items.PartList : null; // useEffect(() => {
  //     if (query) {
  //         if (query.subfilter && query.subfilter.queries) {
  //             setSupplierUrl(query.subfilter.queries[supplier.Id]);
  //         } else {
  //             config.categories.forEach(category => {
  //                 if (category.name.toLowerCase() === query.term.toLowerCase().replace('%20', ' '))
  //                     setSupplierUrl(category.queries[supplier.Id]);
  //             });
  //         }
  //     }
  // }, [query]);

  (0, _react.useEffect)(function () {
    setRowLength(maxItems);
  }, [maxItems]);
  (0, _react.useEffect)(function () {
    if (items) {
      setRowLength(maxItems);
      setFilteredItems((0, _helpers.filterItems)(items, {
        isAvailable: isAvailable,
        searchTerm: searchTerm
      }));
    }
  }, [items, partList, isAvailable, searchTerm]);
  return /*#__PURE__*/_react["default"].createElement(Row, {
    className: "supplier-row",
    minHeight: mobile ? '11.5rem' : '',
    "data-aurora-automation": "store-suppliers-container"
  }, /*#__PURE__*/_react["default"].createElement(Column, {
    className: "supplier-column"
  }, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(SupplierHeader, {
    className: "fade-in",
    mobile: mobile,
    "data-aurora-automation": "store-supplier-header"
  }, loading ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "supplier-img-loading shine"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "supplier-details"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "supplier-name-loading shine"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "supplier-location-loading shine"
  }))) : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "supplier-image",
    src: env.blobUrl + '/' + supplier.SquareLogo
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "supplier-details",
    "data-aurora-automation": "store-supplier-details"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "supplier-name"
  }, supplier.Name), items && /*#__PURE__*/_react["default"].createElement("div", {
    className: "supplier-location fade-in",
    "data-aurora-automation": "store-supplier-location"
  }, /*#__PURE__*/_react["default"].createElement("p", null, items.OnlineOnly ? 'Online shipping availability' : items.Location && items.Location.Street && "".concat(items.Location.Street, ", ").concat(items.Location.City, ", ").concat(items.Location.State, " ").concat(items.Location.Zip)), !items.OnlineOnly && items.Location && items.Location.Street && /*#__PURE__*/_react["default"].createElement("span", {
    onClick: function onClick() {
      return onLocationClick({
        supplier: supplier,
        locations: items.StoreLocations,
        location: items.Location
      });
    }
  }, "Change"))))), /*#__PURE__*/_react["default"].createElement(Row, {
    className: "cards-container ".concat(loading && 'loading'),
    "data-aurora-automation": "store-supplier-items-container"
  }, loading ? (0, _toConsumableArray2["default"])(Array(rowLength)).map(function (u, i) {
    return /*#__PURE__*/_react["default"].createElement(_ItemCard["default"], {
      loading: true,
      key: i,
      index: i,
      env: env
    });
  }) : filteredItems && !_lodash["default"].isEmpty(filteredItems) ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, !mobile && (rowLength - maxItems > 0 ? /*#__PURE__*/_react["default"].createElement("i", {
    className: "far fa-chevron-left arrow left",
    onClick: function onClick() {
      return setRowLength(rowLength - maxItems);
    }
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "arrow left"
  })), filteredItems.map(function (item, i) {
    if (!mobile) {
      if (rowLength - maxItems <= i && i < rowLength) return /*#__PURE__*/_react["default"].createElement(_ItemCard["default"], {
        setCurItem: setCurItem,
        item: item,
        key: i,
        config: config,
        contractId: items.ContractId,
        supplier: supplier,
        env: env
      });
    } else {
      return /*#__PURE__*/_react["default"].createElement(_ItemCard["default"], {
        item: item,
        key: i,
        config: config,
        contractId: items.ContractId,
        supplier: supplier,
        env: env
      });
    }
  }), !mobile && (rowLength < filteredItems.length ? /*#__PURE__*/_react["default"].createElement("i", {
    className: "far fa-chevron-right arrow right",
    onClick: function onClick() {
      return setRowLength(rowLength + maxItems);
    }
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "arrow right"
  }))) : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(Row, {
    className: "no-products fade-in",
    "data-aurora-automation": "supplier-no-items-container"
  }, /*#__PURE__*/_react["default"].createElement(Column, {
    className: "center",
    flex: 1
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "fade-in"
  }, "No results were found"), /*#__PURE__*/_react["default"].createElement("label", {
    className: "italic lite"
  }, "Try to remove filters or search for a different item."))))), filteredItems && !_lodash["default"].isEmpty(filteredItems) && !loading && /*#__PURE__*/_react["default"].createElement(PageCountContainer, {
    className: "page-count-container",
    mobile: mobile,
    maxItems: maxItems
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "count-text small lite"
  }, filteredItems.length, " result", filteredItems.length > 1 && 's', " | Page", ' ', rowLength / maxItems, " of ", Math.ceil(filteredItems.length / maxItems))))));
};

var _default = SupplierRow;
exports["default"] = _default;